module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position1.39512c73.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position1.png
// module id = 3095
// module chunks = 11